import { useMutation } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-recommendations';

export const useCreateNewMediaPlanVersion = () => {
  return useMutation({
    mutationFn: (id: number) => MediaPlan.createNewVersion({ data: { id } }),
  });
};
